module.exports = __webpack_public_path__ + "img/n102_halo.a4b603d2.png";